import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 获取排行榜
interface WithRankJavaJson {
  type: number;
  page: number;
  size: number;
}
export const myGames = (json: WithRankJavaJson): any =>
  http.httpPost({
    url: httpApi.newWeb.withRankJava,
    json,
  });

// 百度联调
interface UploadConvertDatabdVidJson {
  logidUrl: string;
}

export const uploadConvertDatabdVid = (json: UploadConvertDatabdVidJson): any =>
  http.httpPost({
    url: httpApi.newWeb.uploadConvertDatabdVid,
    json,
  });
